import { Partial, Record, String } from "runtypes";
export const ShareableMapping = Record({
  oldID: String,
  newID: String
}).And(
  Partial({
    problem: String
  })
);
//# sourceMappingURL=mapping.js.map
